import React from "react"
import PropTypes from "prop-types"
import { P, A } from "./styles"
import Card from "../card"

const Breadcrumb = ({ pages }) => {
  return (
    <Card style={{ padding: "1rem", marginBottom: "1rem" }}>
      <P>
        {pages
          .map((page) => <A href={page.url}> {page.name} </A>)
          .reduce((val, x) => (val === null ? [x] : [val, "/", x]), null)}
      </P>
    </Card>
  )
}

Breadcrumb.propTypes = {
  pages: PropTypes.array.isRequired
}

Breadcrumb.defaultProps = {
  pages: []
}

export default Breadcrumb
